export const MESSAGE_SENT =
	'DNC\\Messenger\\Laravel\\Events\\Broadcast\\MessageSent'
export const NEW_MATCH = 'App\\Domain\\Matches\\Events\\NewMatchCreated'
